import { useToast } from './useToast'

export function useGlobalAlert() {
  const { showToast } = useToast()

  const showAlert = (msg: string, type: string = 'success') => {
    showToast(msg, type as 'success' | 'error' | 'warning' | 'info')
  }

  return { showAlert }
}
